define( 'form',[ 'jquery', 'lib/utils', 'form-validation', 'pickerdate'],
function( $, utils, FormValidation ) {

	'use strict';

	var Form = function ( $form ) {

		this.$form = $form;
	};


	Form.prototype.init = function() {

		var _this = this,
			$textareas = this.$form.find( '[ data-textarea ]' ),
			$datepickersFuture = this.$form.find( '[ data-el="datepicker-future" ]' ),
			$datepickersPast = this.$form.find( '[ data-el="datepicker-past" ]' ),
			$datepickers = this.$form.find( '[ data-el="datepicker" ]' ),
			$monthpickers = this.$form.find( '[ data-el="monthpicker" ]' ),
			$months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			$shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
			$datepickersWffm = this.$form.find( '[data-el="datepicker-wffm" ]' ),
			$dp,
			dpOptions,
			dpMax,
			dpLabelId,
			$uploaders = $( '[ data-uploader-field ]' ),
			$previewRemovers = this.$form.find( '[ data-uploader-remove ]' ),
			$checkboxToggles = this.$form.find( '[ data-checkbox-toggle ]' ),
			$selectToggle = this.$form.find('[data-select-toggle]'),
			$legendToggleTarget = this.$form.find('[data-toggle-target]'),
			$termsCheckbox = this.$form.find( '[ data-checkbox-terms ]' ),
			$formDataTablePost = this.$form.find('[data-table-post]'),
			$formDataTable = this.$form.find('[data-table-form]'),
			defaultOpts = {
				closeOnSelect: true,
				format: 'd mmmm yyyy',
				formatSubmit: 'd mmmm yyyy',
				onStart: function() {
					// set default date
					var $dp = this.$node,
							date;

					if ( $dp.data('initial-date') ) {
						date = new Date($dp.data('initial-date'));
						this.set('select', [date.getFullYear(), date.getMonth(), date.getDate()]);
					}
				},
				onOpen: function() {
					_this.scrollIntoView( this.$node );
				},
				onClose: function() {
					this.component.$node.parsley().validate();
				}
			};

			// arabic translations
			if (utils.isRTL()) {
				defaultOpts.monthsFull = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
				$shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
				defaultOpts.monthsShort = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
				defaultOpts.weekdaysShort = ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
				defaultOpts.today = 'اليوم';
				defaultOpts.clear = 'مسح';
				defaultOpts.close = 'مغلق';
				defaultOpts.labelMonthNext = 'الشهر القادم';
				defaultOpts.labelMonthPrev = 'الشهر السابق';
				defaultOpts.labelMonthSelect = 'اختر الشهر';
				defaultOpts.labelYearSelect = 'اختر السنة';
				defaultOpts.format = 'd mmmm yyyy';
				defaultOpts.formatSubmit = 'd mmm yyyy';
			};

		//for month pickers

		if ( this.$form.parents( '[ data-wffm ]' ).length > 0 ) {

			// init wffm datepickers
			$datepickersWffm.each( function( i, el ) {
				$dp = $( el ).find( 'input' );

				if ( utils.isTouchDevice() === false || utils.isDevice() === false ) {

					dpLabelId = utils.uniqueID();
					$dp.parents( '.field-border' ).attr( 'id', dpLabelId  );
					dpLabelId = '#' + dpLabelId;

					dpOptions = $dp.data( 'picker-options' );

					if ( typeof dpOptions === 'string' ) {
						dpOptions = JSON.parse( dpOptions );
					} else if ( typeof dpOptions !== 'object' ) {
						dpOptions = {};
					}

					$dp.pickadate(
						$.extend(
							true,
							{
								container: dpLabelId
							},
							dpOptions,
							defaultOpts
						)
					);
					// if dp is has a ref dataset update based on this
					if ( $dp.data('ref') ) {
						$dp.on('change', _this.setConstraints);
					}

					// IE9clicker (1of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
					// and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
					$dp.after( '<span data-clicker="' + dpLabelId + '" class="form-field__datepicker-icon-clicker"></span>' );

				} else {

					$dp.attr( 'type', 'date' );

					// if dp is has a ref dataset update based on this
					if ( $dp.data('ref') ) {
						$dp.on('change', _this.setConstraintsMobile);
					}

				}

			} );

		} else {

			// apply validation
			if(this.$form.attr('form-skipvalidation')!='true'){
					FormValidation.apply( this.$form );
			}
			

			// init textarea char count
			$textareas.each( function( i, el ) {
				_this.countTextChars( el );
			} );

			$textareas.on( 'keyup', function() {
				_this.countTextChars( this );
			} );

			// init datepickers
			$datepickers.each( function( i, el ) {
				$dp = $( el );

				if ( utils.isTouchDevice() === false || utils.isDevice() === false ) {

					dpOptions = $dp.data( 'picker-options' );
					dpLabelId = '#' + $dp.parents( '.form-field' ).attr( 'id' );

					if ( typeof dpOptions === 'string' ) {
						dpOptions = JSON.parse( dpOptions );
					} else if ( typeof dpOptions !== 'object' ) {
						dpOptions = {};
					}

					$dp.pickadate (
						$.extend(
							true,
							dpOptions,
							defaultOpts
						)
					);

					// if dp is has a ref dataset update based on this
					if ( $dp.data('ref') ) {
						$dp.on('change', _this.setConstraints);
					}

					// IE9clicker (1of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
					// and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
					$dp.after( '<span data-clicker="' + dpLabelId + '" class="form-field__datepicker-icon-clicker"></span>' );

				} else {

					$dp.attr( 'type', 'date' );

					// if dp is has a ref dataset update based on this
					if ( $dp.data('ref') ) {
						$dp.on('change', _this.setConstraintsMobile);
					}

				}

			} );

			$datepickersFuture.each( function( i, el ) {
				$dp = $( el );

				if ( utils.isTouchDevice() === false || utils.isDevice() === false ) {

					dpMax = $dp.data( 'date-max' );
					dpOptions = $dp.data( 'picker-options' );
					dpLabelId = '#' + $dp.parents( '.form-field' ).attr( 'id' );

					if ( typeof dpOptions === 'string' ) {
						dpOptions = JSON.parse( dpOptions );
					} else if ( typeof dpOptions !== 'object' ) {
						dpOptions = {};
					}

					if ( typeof dpMax === 'object' ) {
						var maxDay = dpMax[0],
							maxMonth = dpMax[1],
							maxYear = dpMax[2],
							day = new Date();

						day.setDate(day.getDate() + maxDay);
						day.setMonth(day.getMonth() + maxMonth);
						day.setFullYear(day.getFullYear() + maxYear);

						dpMax = {
							max: day
						};

					} else if ( typeof dpMax !== 'object' ) {
						dpMax = {};
					}

					$dp.pickadate (
						$.extend(
							true,
							{
								container: dpLabelId,
								min: new Date()
							},
							dpOptions,
							dpMax,
							defaultOpts
						)
					);

					// if dp is has a ref dataset update based on this
					if ( $dp.data('ref') ) {
						$dp.on('change', _this.setConstraints);
					}


					// IE9clicker (1of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
					// and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
					$dp.after( '<span data-clicker="' + dpLabelId + '" class="form-field__datepicker-icon-clicker"></span>' );

				} else {

					$dp.attr( 'type', 'date' );

					// if dp is has a ref dataset update based on this
					if ( $dp.data('ref') ) {
						$dp.on('change', _this.setConstraintsMobile);
					}
				}

			} );

			$datepickersPast.each( function( i, el ) {
				$dp = $( el );

				if ( utils.isTouchDevice() === false || utils.isDevice() === false ) {

					dpOptions = $dp.data( 'picker-options' );
					dpLabelId = '#' + $dp.parents( '.form-field' ).attr( 'id' );

					if ( typeof dpOptions === 'string' ) {
						dpOptions = JSON.parse( dpOptions );
					} else if ( typeof dpOptions !== 'object' ) {
						dpOptions = {};
					}

					$dp.pickadate (
						$.extend(
							true,
							{
								container: dpLabelId,
								max: new Date()
							},
							dpOptions,
							defaultOpts
						)
					);

					// if dp is has a ref dataset update based on this
					if ( $dp.data('ref') ) {
						$dp.on('change', _this.setConstraints);
					}


					// IE9clicker (1of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
					// and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
					$dp.after( '<span data-clicker="' + dpLabelId + '" class="form-field__datepicker-icon-clicker"></span>' );

				} else {

					$dp.attr( 'type', 'date' );

					// if dp is has a ref dataset update based on this
					if ( $dp.data('ref') ) {
						$dp.on('change', _this.setConstraintsMobile);
					}
				}

			} );

			// init upload image fields
			$uploaders.on( 'change', function(e) {

				//console.log('change')

				// validate on change

				//var myFSO = new ActiveXObject("Scripting.FileSystemObject");
    			//var filepath = e.target.value;
    			//var thefile = myFSO.getFile(filepath);
    			//var sizeIE = thefile.size;

    			
    				var ua = window.navigator.userAgent;
    				var msie = ua.indexOf("MSIE ");
    				var ieVersion = parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)))

    				if (ieVersion === 9) // If Internet Explorer, return version number
    					{
        					
        					$container = $(this).closest('.form-field--upload'),
        					id = $(this).data( 'uploader-field' ),
							$remover = $container.find( '[ data-uploader-remove="' + id + '" ]' );
        					$previewer = $container.find( '[ data-uploader-image="' + id + '" ]' ),
							$filename = $container.find( '[ data-uploader-filename="' + id + '" ]' );
							var inspiration_image = e.target.value.split( '\\' ).pop();

							$previewer.attr( 'src', $previewer.data( 'success' ) );
							$filename.text(inspiration_image).fadeIn();
							$remover.fadeIn();

    					}
    				

    			
  
				
				
				
				var size = $(this)[0].files[0].size;
 				var extension = $(this).val().replace(/^.*\./, '').toLowerCase();
 				var contdd = $(this).closest('.form-field--upload');
 				var $j120 = $(this).closest('.j120-smart-response--button_wrapper');
				var $j120errorFormat = $j120.find('.form-field__input--upload-format-error-message');
				var $j120errorSize = $j120.find('.form-field__input--upload-size-error-message');
				var errorFormat = contdd.find('.form-field__input--upload-format-error-message');
				var errorSize = contdd.find('.form-field__input--upload-size-error-message');
				var __this = $(this)

				errorSize.hide()
				errorFormat.hide()
				$j120errorFormat.each(function(){
					$(this).hide()
				});
				$j120errorSize.each(function(){
					$(this).hide()
				});
				
				var formatList = $(this).data("accepts");
				
				if(formatList){
						var formats = JSON.parse('[' + formatList.toLowerCase() + ']');
					}
				var thisSize =  $(this).attr('data-size');

				


				if(!formatList && !thisSize){
					_this.previewUploadedImage( this );
					
				} else if ((!formatList && thisSize) || (formatList && !thisSize) || (formatList && thisSize)) {

						if(!formatList && thisSize){
							
							if(thisSize >= size){
								_this.previewUploadedImage( this );
							} else{
								errorSize.show();
								$j120errorSize.each(function(){
									$(this).show()
								});
								$(this).val("")
								}
						}
						if(formatList && !thisSize){
							
							if(formats.indexOf(extension) > -1 ){
								_this.previewUploadedImage( this );
							}else{
								errorFormat.show();
								$j120errorFormat.each(function(){
									$(this).show()
								});
								$(this).val("")
							}
						}	
						if(formatList && thisSize){
							
							if (formats.indexOf(extension) > -1 ){
								if(thisSize >= size){
									_this.previewUploadedImage( this );
								} else{
									errorSize.show();
									$j120errorSize.each(function(){
										$(this).show()
									});
									$(this).val("")
								}
							}else{
								errorFormat.show();
								$j120errorFormat.each(function(){
									$(this).show()
								});
								$(this).val("")
							}	
						}

									
				}else{
					
					_this.previewUploadedImage( this );
				}
				
				
					

					$(this).parsley().validate();
			} );

			


			// show file if one is already selected, i.e. browser back
			$uploaders.each( function( i, el ) {
				var $el = $(el)[0];

				if ( $el.files && $el.files[0] ) { _this.previewUploadedImage( el ); }
			});

			// init remove preview upload image buttons
			$previewRemovers.on( 'click', function( e ) {
				e.preventDefault();
				_this.removeUploadedImage( this );
			} );

			// init checkbox toggles
			$checkboxToggles.on( 'click',function(){

				_this.toggleFieldset( $(this) );

			});






			// init terms checkbox
			$.each( $termsCheckbox, function( ){
				var $checkbox = $(this).find('input'),
				$modalTrigger = $(this).find( 'a' ),
				$modalContent = $('[data-content=terms_checkbox]'),
				$agreeButton = $modalContent.find('[data-modal-confirm]'),
				$closeButton = $modalContent.find('[data-close]');

				$modalTrigger.on('click', function( e ) { e.preventDefault(); });

				$agreeButton.on( 'click', function( e ){

					e.preventDefault();

					$checkbox.prop( 'checked', true );
					$closeButton.trigger( 'click' );


				});

			});

		}

		// IE9clicker (2of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
		// and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
		$( '[ data-clicker ]' ).on( 'click', function() {
			$( this ).siblings( '[ data-el="datepicker" ]' ).click();
		} );

	};

	Form.prototype.setConstraints = function(){
		var $el = $( this ),
				ref = $el.data('ref'),
				refDate = $el.pickadate('picker').get('select'),
				minPickers = $( '[data-mindate="' + ref + '"]' ),
				maxPickers = $( '[data-maxdate="' + ref + '"]' );

		refDate = refDate ? refDate.pick : false;

		// update min and max dates
		minPickers.each(function(i,picker){
			var $picker = $(picker),
					currentDate = $picker.pickadate('picker').get('select'),
					minOffset = parseInt($picker.data('mindate-offset'), 10) * 86400000,
					newMin = refDate ? refDate + minOffset: false,
					updateObj = { 'min': new Date(newMin) };

			if (currentDate && newMin) {
				updateObj.select = (currentDate && currentDate.pick < newMin) ? newMin: currentDate.pick;
			}

			$picker.pickadate('picker').set(updateObj);
		});

		maxPickers.each(function(i,picker){
			var $picker = $(picker),
					currentDate = $picker.pickadate('picker').get('select'),
					maxOffset = parseInt($picker.data('maxdate-offset'), 10) * 86400000,
					newMax = refDate ? refDate + maxOffset: false,
					updateObj = { 'max': new Date(newMax) };

			if (currentDate && newMax) {
				updateObj.select = (currentDate && currentDate.pick > newMax) ? newMax: currentDate.pick;
			}

			$picker.pickadate('picker').set(updateObj);
		});
	};

	Form.prototype.setConstraintsMobile = function(){
		var $el = $( this ),
				ref = $el.data('ref'),
				refDate = $el.val(),
				minPickers = $( '[data-mindate="' + ref + '"]' ),
				maxPickers = $( '[data-maxdate="' + ref + '"]' );

		// update min and max dates
		minPickers.prop('min', refDate);
		maxPickers.prop('max', refDate);
	};


	Form.prototype.countTextChars = function( textarea ) {

		var $textarea = $( textarea ),
			$count = $( '[ data-charcount="' + $textarea.data( 'textarea' ) + '" ]' );

		$count.text( $textarea.val().length );
	};


	Form.prototype.scrollIntoView = function( $node ) {

		$( 'html, body' ).animate( {
			scrollTop: ~~$node.offset().top - 60
		}, 750 );
	};


	Form.prototype.previewUploadedImage = function( input ) {
		var $input = $( input ),
				$container = $input.closest('.form-field--upload'),
				id = $input.data( 'uploader-field' ),
				$remover = $container.find( '[ data-uploader-remove="' + id + '" ]' );

		if ( input.files && input.files[ 0 ] ) {

			var reader,
				isImage = false,
				filename = input.files[0].name,
				$previewer =  $container.find( '[ data-uploader-image="' + id + '" ]' ),
				$filename = $container.find( '[ data-uploader-filename="' + id + '" ]' );


			if ( window.FileReader && window.Blob && /image/i.test( input.files[ 0 ].type ) ) {

				reader = new FileReader();

				reader.onload = function ( e ) {
					$previewer.attr( 'src', e.target.result );
				};

				reader.readAsDataURL( input.files[ 0 ] );

				isImage = true;
			}

			if ( isImage === false ) { // not an image - use the 'success' placeholder image
				$previewer.attr( 'src', $previewer.data( 'success' ) );
			}

			// console.log(input.val());
			$filename.text(filename).fadeIn();
			$remover.fadeIn();
		} else {
			this.removeUploadedImage( $remover[0] );
		}

	};


	Form.prototype.removeUploadedImage = function( button ) {

		var $button = $( button ),
			$container = $button.closest('.form-field--upload'),
			id = $button.data( 'uploader-remove' ),
			$previewer =  $container.find( '[ data-uploader-image="' + id + '" ]' ),
			$uploader = $container.find( '[ data-uploader-field="' + id + '" ]' ),
			$filename = $container.find( '[ data-uploader-filename="' + id + '" ]' );

			//console.log($uploader.val())



		$previewer.attr( 'src', $previewer.data( 'src' ) );
		$uploader.val('').focus();
		if (/MSIE/.test(navigator.userAgent)){
				$uploader.replaceWith( $uploader = $uploader.clone( true ) );
			}
		$filename.text('').fadeOut();
		//console.log($uploader.val())
		$button.fadeOut();

	};

	Form.prototype.toggleFieldset = function( $checkox ) {

		var $fieldset = $('#'+$checkox.attr( 'aria-controls' )),
		expanded = $fieldset.attr( 'aria-expanded' ) === 'true',
		pressed = $fieldset.attr( 'aria-pressed' ) === 'true',
		childrenFields = $fieldset.find( 'input[type=text], input[type=number], input[type=email]' ).not( '[data-el=datepicker]' );

		$checkox.attr( 'aria-pressed', pressed = !pressed );
		$fieldset.attr( 'aria-expanded', expanded = !expanded );
		$fieldset.toggleClass( 'fieldset--hidden' );

		if ( !$fieldset.hasClass('fieldset--hidden') ) {
			// enable validation on child fields
			childrenFields.parsley( {
				excluded: 'input.form-field__input--readonly, input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden'
			} );
		}
	};

	return Form;

} );

